import { configureStore, createSlice } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import wishlistReducer from '../../features/wishlist/store/wishlistSlice';
import dashboardReducer from './slices/dashboardSlice';
import companyReducer from './slices/companySlice'; // ✅ Add this import
import authReducer from './slices/authSlice'; // ✅ Add this import
import paymentMethodReducer from './slices/paymentMethodSlice'; // ✅ Add payment method reducer
import loadingReducer from './slices/loadingSlice'; // ✅ Add global loading reducer
import supplierReducer from './slices/supplierSlice'; // ✅ Add supplier reducer
import productBrandReducer from './slices/productBrandSlice'; // ✅ Add product brand reducer
import productCategoryReducer from './slices/productCategorySlice'; // ✅ Add product category reducer
import deliveryNoteReducer from './slices/deliveryNoteSlice'; // ✅ Add delivery note reducer

const initialCustomerState = { customers: [] };
const initialProductState = { products: [] };
const initialInvoiceState = {
  selectedCustomer: null,
  selectedProduct: null,
  quantity: 1,
  price: '',
  vat: 0,
  customText: '',
};

const customerSlice = createSlice({
  name: 'customer',
  initialState: initialCustomerState,
  reducers: {
    setCustomers(state, action) {
      state.customers = action.payload;
    },
    resetCustomers(state) {
      return initialCustomerState;
    },
  },
});

const productSlice = createSlice({
  name: 'product',
  initialState: initialProductState,
  reducers: {
    setProducts(state, action) {
      state.products = action.payload;
    },
    resetProducts(state) {
      return initialProductState;
    },
  },
});

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState: initialInvoiceState,
  reducers: {
    setSelectedCustomer(state, action) {
      state.selectedCustomer = action.payload;
    },
    setSelectedProduct(state, action) {
      state.selectedProduct = action.payload;
    },
    setQuantity(state, action) {
      state.quantity = action.payload;
    },
    setPrice(state, action) {
      state.price = action.payload;
    },
    setVat(state, action) {
      state.vat = action.payload;
    },
    setCustomText(state, action) {
      state.customText = action.payload;
    },
    resetInvoice(state) {
      return initialInvoiceState;
    },
  },
});

export const { setCustomers, resetCustomers } = customerSlice.actions;
export const { setProducts, resetProducts } = productSlice.actions;
export const {
  setSelectedCustomer,
  setSelectedProduct,
  setQuantity,
  setPrice,
  setVat,
  setCustomText,
  resetInvoice,
} = invoiceSlice.actions;

// Action to reset all store slices
export const resetStore = () => (dispatch) => {
  dispatch(resetCustomers());
  dispatch(resetProducts());
  dispatch(resetInvoice());
};

const rootReducer = combineReducers({
  customer: customerSlice.reducer,
  product: productSlice.reducer,
  invoice: invoiceSlice.reducer,
  deliveryNote: deliveryNoteReducer, // ✅ Add delivery note reducer
  wishlist: wishlistReducer,
  dashboard: dashboardReducer,
  company: companyReducer, // ✅ Add company reducer
  auth: authReducer, // ✅ Add auth reducer
  paymentMethod: paymentMethodReducer, // ✅ Add payment method reducer
  loading: loadingReducer, // ✅ Add global loading reducer
  suppliers: supplierReducer, // ✅ Add supplier reducer
  productBrands: productBrandReducer, // ✅ Add product brand reducer
  productCategories: productCategoryReducer, // ✅ Add product category reducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;